
import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';
import "firebase/database";

const config = {
    // ad-hoc or develop
  apiKey: "AIzaSyAsIHY3c-mJ-JbpU25FHcQ_hP0z9W19xxM",
  authDomain: "hammock-holidays.firebaseapp.com",
  projectId: "hammock-holidays",
  storageBucket: "hammock-holidays.appspot.com",
  messagingSenderId: "727602729436",
  appId: "1:727602729436:web:86242be37b24f819e93f19"
};

// export const createUserProfileDocument = async (userAuth, additionalData) => {
//     if(!userAuth) return;

//     const userRef = firestore.doc(`users/${userAuth.uid}`)
//     const snapShot = await userRef.get();
//    console.log('firebase', snapShot)
//     if(!snapShot.exists){
//         const { displayName, email } = userAuth;
//         const createAt = new Date();

//         try {
//             await userRef.set({
//                 displayName,
//                 email,
//                  createAt,
//                  ...additionalData
//             })
//         } catch (error) {
//             console.log('error creatinguser', error.message)
//         }
//     };
//     return userRef;
// }

// Initialize Firebase
// firebase.initializeApp(config);

if (!firebase.apps.length) {
    firebase.initializeApp(config);
} else {
    firebase.app(); // if already initialized, use that one
}

export const db = firebase.database();
export const auth = firebase.auth();
export const firestore = firebase.firestore();

const provider = new firebase.auth.GoogleAuthProvider();

provider.setCustomParameters({ prompt: 'select_account' });

export const signInWithGoogle = () => {
    console.log("provider===>1", provider)
    auth.signInWithPopup(provider).then(response => {

        console.log("response---->", response.additionalUserInfo.isNewUser)
        if (response.additionalUserInfo.isNewUser === true) {
            console.log("logdin sucessfully!")
        } else {
            console.log("User allreday exist!s")
        }
        // localStorage.setItem("accessToken")
    });
}

export const facebookProvider = new firebase.auth.FacebookAuthProvider();
export const signInWithFacebook = () => {
    auth.signInWithRedirect(facebookProvider).then(response => {
        console.log("res", response)
        if (response.additionalUserInfo.isNewUser === true) {
            console.log("logdin sucessfully!")
        } else {
            console.log("User allreday exist!s")
        }
    })
        .catch(err => console.log(err))
}
export default firebase;